import {getJSON} from 'jquery';
import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import {ComputedOptions} from "~knockout/index";
import {getSecondaryScreenVisibilityOptions} from "../../ScreenVisibility";
import {Screen} from "../../Screen";
import {Observable} from '~knockout/index';
import {getGameManager} from '../../../game/GameManager';
import {gameState} from '../../../game/config/GameState';


var template = require('./LevelIntroScreen.html');

class GameIntroScreenComponent extends Screen
{
    overrideVisibility: Observable<boolean>;
    levelText: Observable<string>;

    /**
     * create observable properties to let app elements communicate
     */
    createBindings()
    {
        super.createBindings();

        this.overrideVisibility = ko.observable(false);
        this.levelText = ko.observable();
    }



    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getSecondaryScreenVisibilityOptions('gameplay', 'level-intro');
    }


    /**
     * call a function when we show
     */
    onShow()
    {
        var timeline: TimelineMax;

        timeline = new TimelineMax({
            onStart: () =>
            {
                //  set level display text

                this.levelText('LEVEL ' + getGameManager().currentLevel());

                //  show the element

                this.overrideVisibility(true);
            },
            onComplete: () =>
            {
                this.overrideVisibility(false);
            }});

        timeline.to('.pp-gameplay-level-intro-overlay', 0.5, { opacity: 1, ease: Expo.easeOut });
        timeline.fromTo('.pp-gameplay-level-intro-overlay__title', 0.5, { opacity: 0, marginTop: 20 }, { opacity: 1, marginTop: 0, ease: Back.easeOut }, 0.5);
        timeline.fromTo('.pp-gameplay-level-intro-overlay__super-title', 0.5, { opacity: 0, marginTop: 10 }, { opacity: 1, marginTop: 0, ease: Back.easeOut }, 0.75);
        timeline.to('.pp-gameplay-level-intro-overlay', 0.5, { opacity: 0, ease: Expo.easeOut }, 3);

        //  update the new level display

        getGameManager().setCurrentLevel(gameState.level.currentLevel);
    }
}



/**
 * register this component with knockout
 * @param vizID
 */
export function registerLevelIntroScreenComponent()
{
    ko.components.register('pp-gameplay-level-intro-overlay',
        {
            viewModel: () => { return new GameIntroScreenComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/gameplay/level-intro/LevelIntroScreen.ts